module.exports = __webpack_public_path__ + "static/home-artist-development-mobile-9db157a3e493c593ccc517273f127fcd.webp";